import { jsonStringToDate } from '@df/util/fn/json-string-to-date';

/**
 * Depending on type:
 * Date - just returned
 * number - considered as js timestamp
 * string - considered as is sttring (result of php date('c'))
 * @author Maurycy Ornat maurycy@tomandco.co.uk
 * @param  {number | string | Date | undefined} input Date to convert
 * @param  {resetTime} If true then time will be set to 00:00:00
 * @return {Date}        [description]
 */
export function toDate(input: number | string | Date | undefined, resetTime: boolean | 'utc' = false): Date | undefined {
    if (input === undefined) {
        return undefined;
    }

    if (typeof input === 'number') {
        input = new Date(input);
    } else {
        // try json string
        if (typeof input === 'string') {
            input = jsonStringToDate(input) || input;
        }

        // if still string then try parsing
        if (typeof input === 'string') {
            const ts = Date.parse(input + ' GMT') || Date.parse(input);

            if (ts) {
                input = new Date(ts);
            }
        }
    }
    if (input instanceof Date) {
        if (resetTime === 'utc') {
            input.setUTCMilliseconds(0);
            input.setUTCSeconds(0);
            input.setUTCMinutes(0);
            input.setUTCHours(0, 0, 0, 0);
        } else if (resetTime) {
            input.setMilliseconds(0);
            input.setSeconds(0);
            input.setMinutes(0);
            input.setHours(0);
        }

        return input;
    }

    return undefined;
}
